import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CodeConversionMstDto, Sgke011aResponseInitialhyojiInfo } from 'sg-api';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgke012aService } from '../../services/used-sgke012a.service';
import { SelectBox } from 'cbc-shared-lib';

@Component({
  selector: 'app-sgke010d-search-condition',
  templateUrl: './sgke010d-search-condition.component.html',
  styleUrl: './sgke010d-search-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke010dSearchConditionComponent implements OnInit, OnDestroy {
  /** クリアボタン押下イベント */
  @Output() onClickClearEvent = new EventEmitter<UntypedFormGroup>();
  /** 業務日付 */
  @Input() businessDate: Date = null;
  /** 初期表示情報 */
  @Input() initialhyojiInfo:Sgke011aResponseInitialhyojiInfo
  /** 入金形態リスト */
  rcvmnyKeitaiList: SelectBox[] = [];
  /** 入金取扱機関 */
  indrctRecptFcltList: SelectBox[] = [];

  /** コード変換マスタマップ */
  codeMap: Map<string, CodeConversionMstDto[]>;
  private parentForm: UntypedFormGroup;
  /** 抽出条件情報FormGroup */
  extractionconditionInfo: UntypedFormGroup;
  /** 未精算管理情報FormGroup*/
  kinkoManagementinformation: UntypedFormGroup;


  private onDestroy$ = new Subject();
  /**
   * コンストラクタ
   * @param parent FormGroupDirective
   * @param searchService UsedSgke012aService
   * @param codeConvert CodeConversionMstService
   * @param timeApiService TimeApiService
   * @param fb UntypedFormBuilder
   */
  constructor(
    private parent: FormGroupDirective,
    public searchService: UsedSgke012aService,
    private codeConvert: CodeConversionMstService,
    private fb: UntypedFormBuilder) {
  }
  /**
   * 破棄処理
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('extractionconditionInfo');
  }

  /**
  * 初期処理
  */
  ngOnInit() {
    // 前回検索結果を取得
    let form = this.searchService.searchFormValue;

    // 未精算管理情報の初期設定
    this.kinkoManagementinformation = this.fb.group({
      kinKoMno: { value: null, disabled: false },
      kinkoRrkno: { value: null, disabled: false },
    });
    // FormGroupを初期化
    this.extractionconditionInfo = this.fb.group({
      detailsinformationSearchFlg: this.fb.nonNullable.control({ value: false, disabled: false }),
      payCtrNo: [{ value: null, disabled: false }, Validators.pattern(/^[0-9]+$/)],
      rcvmnyNo: [{ value: null, disabled: false }, Validators.pattern(/^[0-9]+$/)],
      kinkoOccurymdStart: [{ value: null, disabled: false }],
      kinkoOccurymdEnd: this.fb.nonNullable.control({ value: this.businessDate, disabled: false }, Validators.required),
      rcvmnyKeitaiCode: [{ value: null, disabled: false }],
      rcvmnyFcltCode: [{ value: null, disabled: true }],
      kinkoReasonCode: [{ value: null, disabled: false }],
      kinkoStatuscode: this.fb.nonNullable.control({ value: ['01', '02'], disabled: false }, Validators.required),
      kinkoManagementinformation: this.kinkoManagementinformation
    });

    this.parentForm = this.parent.form;
    // 親コンポーネントのformに検索条件formを追加
    this.parentForm.addControl("extractionconditionInfo", this.extractionconditionInfo);
    // 入金形態リスト更新
    this.setSelectList();
    // コード変換マスタ取得
    let dispItemIdList = [
      'S300280',
      'C00970A',
    ];
    //コード変換マスタ共通コンポーネント呼び出し
    this.codeConvert.getCodeConversionMst(dispItemIdList).subscribe(codeMap => {
      // ローカルに保存
      this.codeMap = codeMap;
    });
    //
    if (form) {
      this.extractionconditionInfo.reset(form.extractionconditionInfo);
      // 入金機関リスト作成
      this.onChangeRcvmnyKeitai(form.extractionconditionInfo.rcvmnyKeitaiCode,form.extractionconditionInfo.rcvmnyFcltCode);
      // 再検索処理
      this.parent.ngSubmit.emit();
    }
    this.searchService.clear = true;

  }
  /**
   *
   * コンポーネント内編集チェック
   * @readonly
   * @type {boolean}
   * @memberof Sgke010dSearchConditionComponent
   */
  get touched(): boolean {
    // 検索後はクリアボタン有効
    if (this.searchService.searched) {
      return true;
    }
    // FormControlの編集状態
    return this.isEdited(this.extractionconditionInfo, []);
  }

  /**
   * Form内編集チェック
   * @param form チェックするForm
   * @param ignore  対象外のFormContralNameリスト
   * @returns True:編集済み/False:未編集
   */
  isEdited(form: FormGroup, ignore: string[]): boolean {
    return Object.entries(form.controls)
      .filter(([key, ctrl]) => !ignore.includes(key)) // 対象外を除く
      .some(([key, ctrl]) => {
        if (ctrl instanceof FormControl) {
          // 初期値と異なる場合は修正済
          return ctrl.value?.toString() !== ctrl.defaultValue?.toString();
        } else if (ctrl instanceof FormGroup) {
          // FormGroupの場合は再帰的にチェック
          return this.isEdited(ctrl, ignore);
        } else {
          // それ以外は未修正
          return false;
        }
      });
  }
  /**
   * 入金機関リスト更新
   *
   * @memberof PostPaymentReportInfoComponent
   */
  onChangeRcvmnyKeitai(rcvmnyKeitai:string,indrctRecptFclt: string = null):void{
    // 入金形態リスト
    const parentList = this.initialhyojiInfo?.rcvMethodDivList;
    // 入金形態に紐づく入金機関情報取得
    const parent = parentList?.find(obj => obj.codeValue.includes(rcvmnyKeitai));
    // 入金機関リスト取得
    const childList = parent?.rcvmnyFcltCodeList;
    // 入金機関情報を入金機関リストに設定
    this.indrctRecptFcltList = childList?.map((child) =>{
      let selectBox:SelectBox ={
        value:child.codeValue,
        viewValue:child.aname
      }
      return selectBox;
    });
    // 入金機関リストのコントロールを取得
    let ctrl = this.extractionconditionInfo.controls['rcvmnyFcltCode'];
    // 入金形態リストが選択されていたら、入金機関リストを有効化
    if(rcvmnyKeitai){
      ctrl.enable();
    }else{
      ctrl.disable();
    }
    ctrl.reset(indrctRecptFclt);
}

  /**
   * クリアクリックイベント
   */
  onClickClear() {
    // 入力内容をクリアする
    this.extractionconditionInfo?.reset();
    this.onClickClearEvent.emit();
    let ctrl = this.extractionconditionInfo.controls['rcvmnyFcltCode'];
    ctrl.disable();
    this.searchService.doClear();

  }
  /**
   * 入金形態リスト作成
   */
  private setSelectList(): void {

        // 入金形態リスト
        this.rcvmnyKeitaiList = this.initialhyojiInfo?.rcvMethodDivList?.map((rcvmnyKeitai) => {
          let selectBox: SelectBox = {
            value: rcvmnyKeitai.codeValue,
            viewValue: rcvmnyKeitai.aname
          };
          return selectBox;
        });
  }
}
